<template>
  <b-navbar transparent shadow :mobile-burger="false" active :close-on-click="false" wrapper-class="container">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <h5 v-if="logoText" class="title is-5">{{logoText}}</h5>
        <img v-else :src="logoImageSrc" :alt="talentName">
      </b-navbar-item>
    </template>

    <!--<template slot="burger">
      <a role="button" @click.prevent="$emit('menuClick')" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <b-icon icon="account" custom-class="has-text-primary" />
        <b-icon icon="dots-vertical" />
      </a>
    </template>-->

    <template slot="end">
      <b-navbar-item @click.prevent="$emit('menuClick')">
        <b-icon :class="`is-hidden-mobile mr-2 ${navItemTextColorClass}`" icon="account-circle" />
        <span :class="`is-hidden-mobile is-size-5 ${navItemTextColorClass}`">{{ username }}</span>
        <b-icon :class="dotsIconColor" icon="dots-vertical" />
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
//const talentName = process.env.VUE_APP_TALENT_NAME;

export default {
  props: {
    username: String,
  },
  data() {
    return {
      talentName: process.env.VUE_APP_TALENT_NAME || 'Logo',
      logoText: process.env.VUE_APP_LOGO_TEXT,
      navItemTextColorClass: process.env.VUE_APP_NAV_ITEM_TEXT_COLOR_CLASS || 'has-text-primary-dark',
      dotsIconColor: process.env.VUE_APP_NAV_ITEM_TEXT_COLOR_CLASS || '',
      logoImageSrc: process.env.VUE_APP_LOGO_NAV || '/images/logo.png'
    }
  }
}
</script>

<style scoped>
.navbar, .navbar-menu, .navbar-start, .navbar-end {
  align-items: stretch;
  display: flex;
}
</style>